<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
       테스트
        </v-row>
        </v-container>
</template>
<script>

  
export default {
  name: "App",
  components: {

  },
}

</script>
<style scoped>
#pdfmain {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: black;
  padding: 50px;
}
</style>

